var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    viewBox: "0 0 900 900",
    height: 1200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sustainability-leaf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.785 90h756.75v654H71.785zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sustainability-leaf_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.785 262H554v584.75H71.785zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sustainability-leaf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7f9840",
    d: "M364.168 743.559c-174.879 0-292.383-103.676-292.383-257.985C71.785 366.625 143.848 90 811.335 90c6.95 0 13.243 4.195 15.895 10.629a17.16 17.16 0 01-3.718 18.746c-60.332 60.367-133.91 149.113-167.344 301.117-24.867 112.895-71.133 323.067-292 323.067zm406.578-618.817C171.953 135.266 106.184 379.32 106.184 485.574c0 133.738 103.675 223.586 257.984 223.586 178.316 0 226.852-152.832 258.394-296.062 30.2-137.418 91.325-225.786 148.184-288.356zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sustainability-leaf_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7f9840",
    d: "M88.984 846.75c-9.492 0-17.199-7.707-17.199-17.2 0-102.265 177.32-430.382 456.871-565.843 8.532-4.094 18.817-.55 22.977 7.98 4.129 8.532.55 18.817-7.98 22.981-282.301 136.797-437.47 454.496-437.47 534.883 0 9.492-7.706 17.199-17.199 17.199zm0 0"
  }))));
}

export default __webpack_public_path__ + "6469e1ef7947df18be76888dab7a34d4.svg";
export { SvgSustainabilityLeaf as ReactComponent };